import { makeStyles } from '@material-ui/core';

import { neutral, orange, teal } from 'shared/styles/colors';

export default makeStyles({
  root: {
    display: 'flex',
    alignItems: 'stretch',
    padding: '0.25rem',
    borderRadius: '0.625rem',
    backgroundColor: neutral.D6,
    width: '100%',
    boxSizing: 'border-box',
  },
  tab: {
    flex: '1 1 0',
    minWidth: 0,
    height: '2.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    padding: '0 1rem',
    borderRadius: '0.625rem',
    border: '1px solid transparent',
    backgroundColor: 'transparent',
    color: neutral.D15,
    fontFamily: 'inherit',
    fontWeight: 600,
    fontSize: '0.8125rem',
    lineHeight: '1.21875rem',
    textTransform: 'none',
    cursor: 'pointer',
    transition: 'background-color 120ms ease, color 120ms ease',
    '& svg path': {
      transition: 'stroke 120ms ease',
    },
    '&:not($active) svg path': {
      stroke: neutral.D15,
    },
    '&:hover:not($active)': {
      color: neutral[100],
    },
  },
  active: {
    backgroundColor: neutral.white,
    border: `1px solid ${neutral.D10}`,
    color: neutral[100],
    boxShadow: `0 0.0625rem 0.09375rem ${neutral.black}1A`,
  },
  icon: {
    width: '0.875rem',
    height: '0.875rem',
    flexShrink: 0,
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '1.375rem',
    height: '1.375rem',
    padding: '0 0.375rem',
    borderRadius: '50%',
    fontSize: '0.6875rem',
    fontWeight: 600,
    lineHeight: '1.03125rem',
    backgroundColor: neutral[30],
    color: neutral.D16,
    flexShrink: 0,
  },
  badgeActiveInProgress: {
    backgroundColor: teal[50],
    color: neutral.white,
  },
  badgeActiveScheduled: {
    backgroundColor: orange.D5,
    color: neutral.white,
  },
});
